"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitize = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _dompurify = _interopRequireDefault(require("dompurify"));

var _excluded = ["content"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var sanitize = function sanitize(iframe) {
  return _dompurify["default"].sanitize(iframe, {
    ALLOWED_TAGS: ['iframe', 'div'],
    ALLOWED_ATTR: ['id', 'class', 'className', 'src', 'style', 'frameborder', 'gesture', 'allow', 'allowfullscreen', 'width', 'height']
  });
};

exports.sanitize = sanitize;

var _default = function _default(_ref) {
  var content = _ref.content,
      other = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, other, {
    dangerouslySetInnerHTML: {
      __html: sanitize(content)
    }
  }));
};

exports["default"] = _default;